// loading.interceptor.ts
import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { from, Observable, of, throwError } from 'rxjs';
import { finalize, catchError, switchMap } from 'rxjs/operators';
import { SpinnerService } from '../services/spinner.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  constructor(private spinnerService: SpinnerService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = req.url;

    // Ignorar URLs específicas
    const skipSpinner = url.includes('i18n') || url.includes('azure-api.net') || url.includes('data:image');
    const response$ = next.handle(req).pipe(
      catchError((err: unknown) => {
        if (!skipSpinner) console.error('Error en HTTP', err);
        if (err instanceof HttpErrorResponse && err.error instanceof Blob) {
          return from(err.error.text()).pipe(
            catchError(() => of(null)),
            switchMap(body => throwError(() => body === null ? err : new HttpErrorResponse({
              ...err,
              error: body,
              url: err.url ?? undefined
            })))
          );
        }
        return throwError(() => err);
      })
    );

    if (skipSpinner) {
      return response$;
    }

    // En el interceptor
    this.spinnerService.show();
    console.log('Spinner ON');

    return response$.pipe(
      finalize(() => {
        this.spinnerService.hide();
        console.log('Spinner OFF');
      })
    );

  }
}
